import { FhhBreadcrumbs } from '@/components/breadcrumbs/Breadcrumbs';
import { Sorting } from '../sorting/Sorting';
import type { Filters, ResultDataStats } from '@/domain';

type TopBarProps = {
    stats: ResultDataStats;
    onFilterChanged: (filters: Filters) => void;
    filters: Filters;
};

export const TopBar = ({ stats, onFilterChanged, filters }: TopBarProps) => (
    <div className="grid grid-cols-2 hidden md:grid items-baseline ml-16 mb-8 mt-12" data-testid="topBar">
        <FhhBreadcrumbs />
        <Sorting filters={filters} onFilterChanged={onFilterChanged} />
    </div>
);
